module.exports = __webpack_public_path__ + "static/media/logo-novonordiskfonden.a4d0e6b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logos/logo-novonordiskfonden.png
// module id = 1491
// module chunks = 0